export const LedgerAccountsTypeDefault = "assets";

export const LedgerAccountsType = [
    {
        text: "Ativo",
        value: LedgerAccountsTypeDefault,
    },
    {
        text: "Passivo",
        value: "liabilities",
    },
    {
        text: "Despesas",
        value: "expenses",
    },
    {
        text: "Receitas",
        value: "revenues",
    },
];

export const LedgerAccountsTypeValues = LedgerAccountsType.map((rec) => rec.value);

export default function ChartAccountsUtils() {
    const LedgerAccountsTypeText = (value) => {
        return LedgerAccountsType.find((rec) => rec.value === value)?.text || null;
    };

    return {
        LedgerAccountsTypeText,
    };
}
